import { render, staticRenderFns } from "./HighClassWhiteCollarDataTable.vue?vue&type=template&id=c172d532&scoped=true"
import script from "./HighClassWhiteCollarDataTable.vue?vue&type=script&lang=js"
export * from "./HighClassWhiteCollarDataTable.vue?vue&type=script&lang=js"
import style0 from "./HighClassWhiteCollarDataTable.vue?vue&type=style&index=0&id=c172d532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c172d532",
  null
  
)

export default component.exports